import React from "react";
import { AlertCircle, FileText, Brain } from "lucide-react";
import {
    Alert,
    AlertDescription,
} from "../../../../components/ui/AlertDetailedReport";
import detailedAnalysisIcon from "../../../../assets/images/detailed_analysis_purple.svg";
import infomationIcon from "../../../../assets/images/detailed_report_informaiton_purple.svg";
import {
    DetailOpeningAndStructure,
    OpeningAndStructure as ComponentOpeningAndStructure,
} from "../../types";
import AnalysisSection from "./components/AnalysisSection";
import AnalysisDetail from "./components/AnalysisDetail";
import InfoList from "./components/InfoList";

export interface OpeningStructureProps {
    data: DetailOpeningAndStructure;
    componentAnalysisSection?: ComponentOpeningAndStructure;
}

const OpeningStructure = ({
    data,
    componentAnalysisSection,
}: OpeningStructureProps) => {
    const { clarifyingQuestions, framework, hypothesis, topCandidateResponse } =
        data;
    return (
        <div className="space-y-6">
            {/* ================= Clarifying Questions Section ================ */}
            <AnalysisSection
                title="Clarifying Questions"
                status={
                    clarifyingQuestions.status ||
                    componentAnalysisSection?.criteria.clarifying_questions
                        .status ||
                    componentAnalysisSection?.overallStatus
                }>
                {/* "Detailed analysis" block */}
                <AnalysisDetail
                    icon={<img src={detailedAnalysisIcon} />}
                    title="Detailed analysis"
                    className="!border-0 !shadow-none">
                    {clarifyingQuestions.detailedAnalysis}
                </AnalysisDetail>

                {/* "All available information" bullet list */}
                {/* <AnalysisDetail
          title="All available information"
          icon={<img src={infomationIcon} />}
          className="!border-0 !shadow-none"
        >
          <InfoList
            items={clarifyingQuestions.allAvailableInformation
              .split("\n")
              .filter(Boolean)}
          />
        </AnalysisDetail> */}
            </AnalysisSection>

            {/* ================== Framework Section ================== */}
            <AnalysisSection
                title="Framework"
                status={
                    framework.status ||
                    componentAnalysisSection?.criteria.framework.status ||
                    componentAnalysisSection?.overallStatus
                }>
                <AnalysisDetail
                    icon={<img src={detailedAnalysisIcon} />}
                    title="Detailed analysis">
                    {framework.detailedAnalysis}
                </AnalysisDetail>
                <AnalysisDetail
                    title="Sample framework"
                    icon={<img src={infomationIcon} />}
                    className="!border-0 !shadow-none">
                    <InfoList
                        items={framework.sampleFramework
                            .split("\n")
                            .filter(Boolean)}
                    />
                </AnalysisDetail>
            </AnalysisSection>

            {/* ================== Hypothesis Section ================== */}
            <AnalysisSection
                title="Hypothesis"
                status={
                    hypothesis.status ||
                    componentAnalysisSection?.criteria.hypothesis.status ||
                    componentAnalysisSection?.overallStatus
                }>
                <AnalysisDetail
                    icon={<img src={detailedAnalysisIcon} />}
                    title="Detailed analysis">
                    {hypothesis.detailedAnalysis}
                </AnalysisDetail>
            </AnalysisSection>
        </div>
    );
};

export default OpeningStructure;
